




























































import {
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import { focus } from '@front-app/directives/focus';
import { VueConstructor } from 'vue';
import { Size } from '@front-app/components/constants';
import { useOnEveryEntry } from '@front-app/hooks/useOnEntry';

export default defineComponent({
	directives: {
		focus,
	},
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			default: 'router-link',
		},
		title: {
			type: String,
			default: '\xa0',
		},
		subtitle: {
			type: String,
			default: '\xa0',
		},
		imgSrc: {
			type: String,
			default: '',
		},
		imgAlt: {
			type: String,
			default: '',
		},
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		noImage: Boolean,
		isFocused: Boolean,
		disableAutofocus: Boolean,
	},
	setup(props, ctx) {
		onMounted(() => {
			ctx.emit('mounted');
		});
		const el = ref(null);
		useOnEveryEntry(el, () => {
			ctx.emit('visible');
		});
		return { Size, el };
	},
});
